import type { ComponentCommonProps } from '../../types/props.js'

export interface SpacerProps extends ComponentCommonProps, React.HTMLAttributes<HTMLDivElement> {
  data: {
    space: 'default' | 'fixed'
  }
}
